import { piOhDeepMerge } from "@/utils/object.helper";
/**
 * 折线图 -  configData 配置对象   div
 *

 }
 */
export const getLineData = (configData, optionData) => {
    const title = getTitle(configData, optionData);
    const tooltip = getTooltip(configData, optionData);
    const legend = getLegend(configData, optionData);
    const grid = getGrid(configData, optionData);
    const toolbox = getToolbox(configData, optionData);
    const yAxis = getYAxis(configData, optionData);
    const xAxis = getXAxis(configData, optionData);
    const series = getSeries(configData, optionData);
    const option = {
        title: title,
        tooltip: tooltip,
        color: optionData.color || [],
        legend: legend,
        grid: grid,
        toolbox: toolbox,
        xAxis: xAxis,
        yAxis: yAxis,
        series: series,
    };
    if (optionData.dataZoom) {
        option.dataZoom = optionData.dataZoom;
    }
    return option;
};
const getTitle = (configData, optionData) => {
    let title = {
        text: "",
        show: optionData.title ? true : false,
        top: "-5",
        left: "0%",
        textStyle: {
            color: "#101A25",
            fontSize: 14,
            lineHeight: 22,
            fontWeight: "600",
        },
    };
    if (optionData.legend) {
        title = piOhDeepMerge(title, optionData.title);
    }
    return title;
};
const getTooltip = (configData, optionData) => {
    let tooltip = {
        trigger: "axis",
        show: true,
    };
    if (optionData.legend) {
        tooltip = piOhDeepMerge(tooltip, optionData.tooltip);
    }
    return tooltip;
};
const getLegend = (configData, optionData) => {
    let legend = {
        data: [],
        textStyle: {
            color: "#646A71",
        },
        itemHeight: 8,
        itemWidth: 8,
        show: false,
    };
    if (optionData.series && optionData.series.length > 0) {
        legend.data = optionData.series.map((item) => {
            return item.name;
        });
    }
    if (optionData.legend) {
        legend = piOhDeepMerge(legend, optionData.legend);
    }
    return legend;
};
const getGrid = (configData, optionData) => {
    let grid = {
        top: "32",
        left: "1%",
        right: "1%",
        bottom: "0%",
        containLabel: true,
    };
    if (optionData.grid) {
        grid = piOhDeepMerge(grid, optionData.grid);
    }
    return grid;
};
const getToolbox = (configData, optionData) => {
    let toolbox = {
        show: false,
    };
    if (optionData.toolbox) {
        toolbox = piOhDeepMerge(toolbox, optionData.toolbox);
    }
    return toolbox;
};
const getXAxis = (configData, optionData) => {
    let xAxis = {
        show: true,
        type: "category",
        boundaryGap: true,
        data: [],
        axisLine: {
            show: false,
        },
        axisTick: {
            show: false,
            // alignWithLabel: true,
            inside: true,
        },
        axisLabel: {
            color: "#A4A8AC",
        },
    };
    if (optionData.series && optionData.series.length > 0) {
        let dataArr = []; // x轴名称数组
        if (optionData.series[0].data) {
            dataArr = optionData.series[0].data.map((item) => {
                return item.name;
            });
        }
        xAxis.data = dataArr;
    }
    if (optionData.xAxis) {
        xAxis = piOhDeepMerge(xAxis, optionData.xAxis);
    }
    return xAxis;
};
/**
 * Y轴数据
 * @param configData
 * @param optionData
 * @returns
 */
const getYAxis = (configData, optionData) => {
    const yAxis = {
        type: "value",
        show: true,
        nameTextStyle: {
            color: "#A4A8AC",
            align: "left",
        },
        axisLine: {
            show: false,
        },
        axisLabel: {
            // interval: 10,
            margin: -10,
            color: "#A4A8AC",
        },
        axisTick: {
            show: false,
            alignWithLabel: true,
            inside: true,
            length: 0,
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: "#EFEFF0",
                type: "dashed",
            },
        },
    };
    const yAxisArr = [];
    if (Object.prototype.toString.call(optionData.yAxis) === "[object Array]") {
        if (optionData.yAxis[0]) {
            const yAxisOne = JSON.parse(JSON.stringify(yAxis));
            yAxisArr.push(piOhDeepMerge(yAxisOne, optionData.yAxis[0]));
        }
        if (optionData.yAxis[1]) {
            const yAxisTow = JSON.parse(JSON.stringify(yAxis));
            yAxisTow.nameTextStyle.align = "right";
            yAxisTow.axisLabel.margin = -20;
            yAxisArr.push(piOhDeepMerge(yAxisTow, optionData.yAxis[1]));
        }
        return yAxisArr;
    }
    else if (optionData.yAxis) {
        if (optionData.series && optionData.series.length == 1) {
            yAxis.name = optionData.series[0].name;
        }
        return piOhDeepMerge(yAxis, optionData.yAxis);
    }
    else {
        return yAxis;
    }
};
/**
 * 加上默认配置
 * @param configData
 * @param optionData
 * @returns
 */
const getSeries = (configData, optionData) => {
    const series = [];
    if (optionData.series && optionData.series.length > 0) {
        const defaultData = {
            smooth: true,
            symbol: "circle",
            type: "line",
        };
        optionData.series.map((item) => {
            series.push(piOhDeepMerge({ ...defaultData }, item));
        });
    }
    return series;
};
